module.exports = __webpack_public_path__ + "static/top-clutch-logo-ec7f047efeaef447df682c7c7563651b.svg";